import Nullstack from 'nullstack';
export default function IconBallVolleyball({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ball-volleyball",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("path", {
    d: "M12 12a8 8 0 0 0 8 4"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 13.5a12 12 0 0 0 8.5 6.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 12a8 8 0 0 0 -7.464 4.928"
  }), "   ", Nullstack.element("path", {
    d: "M12.951 7.353a12 12 0 0 0 -9.88 4.111"
  }), "   ", Nullstack.element("path", {
    d: "M12 12a8 8 0 0 0 -.536 -8.928"
  }), "   ", Nullstack.element("path", {
    d: "M15.549 15.147a12 12 0 0 0 1.38 -10.611"
  }), " ");
}